import { toUSPhoneNumber } from '@nwwp/utils'

/** Which Contact field Closeable uses to match save-record upserts (one per send). */
export type CloseableUpsertKeys = { external_client_id: string } | { primary_phone: string } | { primary_email: string }

export function normalizeCloseablePhone(phone: string | null | undefined): string | null {
  if (!phone?.trim()) {
    return null
  }
  try {
    return toUSPhoneNumber(phone)
  } catch {
    return null
  }
}

export function resolveCloseableUpsertKeys(input: {
  externalId: string | null | undefined
  phone: string | null | undefined
  email: string | null | undefined
}): CloseableUpsertKeys | null {
  if (input.externalId?.trim()) {
    return { external_client_id: input.externalId.trim() }
  }

  const normalizedPhone = normalizeCloseablePhone(input.phone)
  if (normalizedPhone) {
    return { primary_phone: normalizedPhone }
  }

  if (input.email?.trim()) {
    return { primary_email: input.email.trim().toLowerCase() }
  }

  return null
}

/** Single string for Salesforce lookup — same priority as outbound upsert keys. */
export function correlationIdFromCloseableWebhookPayload(input: {
  external_client_id?: string | null
  primary_phone?: string | null
  primary_email?: string | null
}): string | null {
  const keys = resolveCloseableUpsertKeys({
    externalId: input.external_client_id,
    phone: input.primary_phone,
    email: input.primary_email,
  })
  if (!keys) {
    return null
  }
  if ('external_client_id' in keys) {
    return keys.external_client_id
  }
  if ('primary_phone' in keys) {
    return keys.primary_phone
  }
  return keys.primary_email
}
